function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M-1-1h202v52H-1z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("text", {
  fontFamily: "'Trebuchet MS', Gadget, sans-serif",
  fontSize: 20,
  y: 32.129,
  x: 17.999,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#fff"
}, "Brandbase"), React.createElement("ellipse", {
  ry: 0.185,
  cy: 54.792,
  cx: 197.222,
  fill: "#fff"
}));

var SvgBrandbase = function SvgBrandbase(props) {
  return React.createElement("svg", _extends({
    width: 200,
    height: 50
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPCEtLSBDcmVhdGVkIHdpdGggTWV0aG9kIERyYXcgLSBodHRwOi8vZ2l0aHViLmNvbS9kdW9waXhlbC9NZXRob2QtRHJhdy8gLS0+CiA8Zz4KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+CiAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBoZWlnaHQ9IjUyIiB3aWR0aD0iMjAyIiB5PSItMSIgeD0iLTEiLz4KICA8ZyBkaXNwbGF5PSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgeT0iMCIgeD0iMCIgaGVpZ2h0PSIxMDAlIiB3aWR0aD0iMTAwJSIgaWQ9ImNhbnZhc0dyaWQiPgogICA8cmVjdCBmaWxsPSJ1cmwoI2dyaWRwYXR0ZXJuKSIgc3Ryb2tlLXdpZHRoPSIwIiB5PSIwIiB4PSIwIiBoZWlnaHQ9IjEwMCUiIHdpZHRoPSIxMDAlIi8+CiAgPC9nPgogPC9nPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDx0ZXh0IHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsMCwwKSAiIHhtbDpzcGFjZT0icHJlc2VydmUiIHRleHQtYW5jaG9yPSJzdGFydCIgZm9udC1mYW1pbHk9IidUcmVidWNoZXQgTVMnLCBHYWRnZXQsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjAiIGlkPSJzdmdfMiIgeT0iMzIuMTI4NzU4IiB4PSIxNy45OTg4NCIgc3Ryb2tlLXdpZHRoPSIwIiBzdHJva2U9IiMwMDAiIGZpbGw9IiNmZmZmZmYiPkJyYW5kYmFzZTwvdGV4dD4KICA8ZWxsaXBzZSByeT0iMC4xODUxODUiIGlkPSJzdmdfNSIgY3k9IjU0Ljc5MTY2MiIgY3g9IjE5Ny4yMjIwODkiIHN0cm9rZS1vcGFjaXR5PSJudWxsIiBzdHJva2Utd2lkdGg9IjAiIHN0cm9rZT0iIzAwMCIgZmlsbD0iI2ZmZmZmZiIvPgogPC9nPgo8L3N2Zz4=";
export { SvgBrandbase as ReactComponent };